
import WDElement from '../wd-element';
import WDNavbarMenu from '../navbar/wd-navbar-menu';
import WDUtil from '../../core/wd-util';
import WDButton from '../button/wd-button';
import { WDRest } from '../../core/fetch/index.js';
import { WDFormSelect } from '../form/wd-form-select';
import { WDFormHidden } from '../form/wd-form-hidden';

import './wd-filter-matches';

/**
	*	@param cfg {Object} 
	*	{
	*		filters: [
	*			{	label:'Search String', type:'text', name:'search_string', static: true },												static: always shows, no match value or display
	*			{	label:'Item List', type:'list', name:'item_list', options:this.getOptions(), simple:true },			simple: no match field, always "equals"
	*			{	label:'Adv List', type:'list', name:'advanced_list', options:this.getOptions() },								
	*			{ label:'Sale Date', type:'date', name:'sale_date' },
	*		],
	*		value: [ 
	*			{ field:'area_acres', match: 'greater_than_equals', value:'50'} 
	*		]
	* }
	*/

export default class WDNavbarFilter extends WDNavbarMenu
{

	#controlBtn;
	#filters = [];

	#config = {
		filters: [],
		allow_minimize: true
	};

	constructor(cfg)
	{
		super(cfg).classList.add('wd-navbar-menu');

		WDUtil.merge(this.#config, cfg);

		//given a uri -> use the config to figure out our default fetch class
		if (cfg?.uri)
		{
			const f = new WDRest(cfg.uri);
			this.initFromFetch(f);
		}
		//given a fetch object directly
		else if (cfg?.fetch)
		{
			this.initFromFetch(cfg.fetch);
		}
		//just init and move on
		else
		{
			this.initFilters();
		}
	};

	initFromFetch(f)
	{
		f.req().then(results =>
		{
			this.#config.filters = results;
			this.initFilters();
		});

	};

	initFilters()
	{
		if (this.#config?.value && this.#config.value.length > 0)
		{
			this.value = this.#config.value;
		}
		else
		{
			this.#config.filters.forEach(filterCfg =>
			{
				this.addFilter(filterCfg);
			});
		}

		//fire the event out of the main loop so we can subscribe after init
		setTimeout(() => this.trigger('filter:ready'), 10);
	};

	addFilter(filterCfg)
	{
		if (filterCfg?.static)
		{
			return this.addFilterToMenu(filterCfg);
		}
		else
		{
			this.addFilterToControl(filterCfg);
			return null;
		}

	};

	get controlBtn()
	{
		if (!this.#controlBtn)
		{
			this.#controlBtn = new WDButton({ icon: 'fa-solid fa-filter' });
			this.#controlBtn.classList.add('filters-control-btn');
			this.prepend(this.#controlBtn);
		}

		return this.#controlBtn;
	};

	handleFilterApply(f)
	{
		this.trigger('filter:apply');
	};

	addFilterToControl(filterCfg)
	{
		const dd = this.controlBtn.dropdown;

		//if there is a label and it's an input form, automatically force to advanced mode
		const formTypes = ['text', 'number', 'date', 'datetime', 'email'];
		if (filterCfg.label && formTypes.includes(filterCfg.type)) filterCfg.mode = 'advanced';

		const item = dd.add(filterCfg.label);
		item.on('click', () =>
		{
			const f = this.addFilterToMenu(filterCfg);
			if (filterCfg?.mode == 'advanced') f.dropdown.show();
		});

		if (filterCfg.icon) item.icon = filterCfg.icon;

		return item;
	};

	addFilterToMenu(filterCfg)
	{
		let f = null;

		if (!filterCfg?.mode || filterCfg?.mode == 'standard')
		{
			f = new WDNavbarFilterItem(filterCfg);
		}
		else
		{
			f = new WDNavbarFilterAdvancedItem(filterCfg, this);
		}

		f.on('filter:apply', (f) => this.handleFilterApply(f));
		this.list.append(f);

		return f;
	};

	/**
		* remove any currently displayed filters
		*/
	reset()
	{
		this.empty();
		this.#controlBtn = null;
	};

	/**
		* verifies a filter value is set for the filter
		*/
	filterHasValue(filter)
	{
		let ret = true;
		const val = filter.value;

		if (val === null || val === undefined)
		{
			ret = false;
		}
		else if (typeof (val) == 'object')
		{
			if (val instanceof Array && val.length == 0) ret = false;
		}
		else if (String(val).length == 0)
		{
			ret = false;
		}

		return ret;
	};

	get value()
	{
		const values = [];

		this.itemArray.forEach(f =>
		{
			const filterVal = f.value;
			if (this.filterHasValue(filterVal)) values.push(filterVal);
		});

		return values;
	};

	getFilterWithName(formName)
	{
		return this.itemArray.find( x => x.config.name == formName );
	};

	set value(values)
	{
		this.reset();

		this.#config.filters.forEach(filterCfg =>
		{
			this.addFilter(filterCfg);
		});

		values.forEach(v =>
		{

			//get the filter config from the value field name
			const cfg = this.#config.filters.find(f => f.name == v.field);

			if (cfg?.static)
			{
				this.itemArray.forEach(f =>
				{
					if (f.config.name == v.field) f.value = v;
				});
			}
			else
			{
				this.addFilterToMenu(cfg);
			}

		});
	};

};

class WDNavbarFilterItem extends WDElement
{

	#config = {};
	#clearBtn;
	#matchForm = null;
	#valueForm = null;
	#timer;

	constructor(cfg)
	{
		super().classList.add('wd-navbar-menu-item', 'wd-navbar-filter-item', 'wd-navbar-filter-type-' + cfg.type);
		if (cfg?.static == true) this.classList.add('is-static');

		this.#config = cfg;

		if (this.#config.type == 'boolean')
		{
			this.#config.options = [{ label: 'Yes', value: '1' }, { label: 'No', value: '0' }];
			this.#config.type = 'dropdown';
		}

		if (this.#config.label && cfg?.mode != 'advanced') 
		{
			if (this.isDropdown)
			{
				if (!this.#config.button) this.#config.button = {};
				this.#config.button.prefix = this.#config.label;
			}
			else
			{
				this.classList.add('has-label');

				const lbl = wdc('<label/>');
				lbl.append(this.#config.label + ':');
				this.append(lbl);
			}
		}

		this.matchForm;
		this.valueForm;
		this.clearBtn;

		//passed a value at init
		if (cfg?.value !== null && cfg?.value !== undefined) this.value = cfg.value;
	};

	get config() { return this.#config; };

	get isDropdown()
	{
		const dds = ['dropdown', 'dropdownmulti', 'boolean'];
		return dds.includes(this.#config.type);
	};

	get value()
	{
		return {
			field: this.#config.name,
			match: this.#matchForm.value,
			value: this.#valueForm ? this.#valueForm.value : this.#config?.value
		};
	};

	set value(data)
	{
		//if not passed an object, then we were passed a single value in the config for setting up the filters
		if (typeof (data) !== 'object') data = { value: data };

		if (!data?.match) data.match = this.#config.type == 'text' ? 'contains' : 'equals';

		this.matchForm.value = data.match;
		
		if (this.#valueForm && typeof(this.#valueForm) == 'object')
		{
			this.#valueForm.value = data.value;
		}
		else
		{
			this.on('valueform:added', () => this.#valueForm.value = data.value );
		}

	};

	get matchOptions()
	{
		return (typeof (WDFilterMatches[this.#config.type]) != 'undefined') ? WDFilterMatches[this.#config.type] : WDFilterMatches.text;
	};

	get matchForm()
	{
		if (!this.#matchForm)
		{
			//can't figure out how to just inherit this
			if (this.#config.mode == 'advanced')
			{
				const matchCfg = {
					options: this.matchOptions,
					allow_clear: false
				};

				this.#matchForm = new WDFormSelect(matchCfg);
				this.#matchForm.on('change', () =>
				{
					if (this.hasValue()) this.triggerApply();
				});
			}
			else
			{
				//const matchVal = this.#config.type == 'text' ? 'contains' : 'equals';
				this.#matchForm = new WDFormHidden({ name: 'match', value: 'equals' });
			}

			this.append(this.#matchForm);
		}

		return this.#matchForm;
	};

	hasValue()
	{
		return String(this.#valueForm.value).length > 0;
	};

	tmpVal()
	{
		this.val = function () { return this.#config?.value; };
	};

	get valueForm()
	{
		if (!this.#valueForm)
		{
			this.#config.autocomplete = 'off';
			const fn = `WDForm${this.#config.type.toLowerCase().replace('-', '').capitalize()}`;

			this.#valueForm = true;

			import('wd').then(module =>
			{
				this.#valueForm = new module[fn](this.#config);

				if (this.#config.type == 'text')
				{
					this.#valueForm.on('input', () => this.triggerDelayedApply());
				}
				else
				{
					this.#valueForm.on('change', () => this.triggerApply());
				}

				if (this.#clearBtn) this.#clearBtn.before(this.#valueForm);
				else this.append(this.#valueForm);

				this.trigger('valueform:added');
			});

		}

		return this.#valueForm;

	};

	triggerDelayedApply()
	{
		if (this.#timer) clearTimeout(this.#timer);
		this.#timer = setTimeout(() => this.triggerApply(), 500);
	};

	triggerApply()
	{
		this.trigger('filter:apply');
	};

	get clearBtn()
	{
		if (!this.#clearBtn)
		{
			this.#clearBtn = wdc('<span class="fa-solid fa-xmark"/>');
			this.#clearBtn.addEventListener('click', () => this.clear());

			this.append(this.#clearBtn);
		};

		return this.#clearBtn;
	};

	clear() { 
		this.remove(); 
		this.triggerApply();
	};

	get valueLabel()
	{
		const hasOptions = ['select', 'dropdown', 'dropdownmulti', 'list', 'checklist'];
		let labelVal = this.#valueForm.value;

		//dropdown - has a method for generating the label
		if (this.#valueForm?.valueLabel !== undefined)
		{
			labelVal = this.#valueForm.valueLabel;
		}
		//it's a type with options, handle multiple/single selection option
		else if (hasOptions.indexOf(this.#config.type) != -1)
		{
			const isMultiple = this.#valueForm.config.multiple == true;

			labelVal = (isMultiple) ? this.multipleLabel : this.singleLabel;
		}

		return labelVal;
	};

	get singleLabel()
	{
		const checkVal = this.#valueForm.value;
		const labelVal = this.#valueForm.options.find( opt => opt.value == checkVal );

		return (labelVal !== null) ? labelVal : 'Not Selected';
	};

	get multipleLabel()
	{
		const checkVals = this.#valueForm.value;
		const labels = this.#valueForm.options
							.filter( x => checkVals.includes(x.value) )
							.map( x => x.value );

		return (labels.length > 0) ? labels.join(', ') : 'Not Selected';
	};

};



/**
	advanced filter 
	*/
class WDNavbarFilterAdvancedItem extends WDNavbarFilterItem
{
	#button;
	#matchForm = null;
	#applyBtn = null;
	#hideBtn = null;

	constructor(cfg)
	{
		//try to create a label from the name if we don't have one
		super(cfg).classList.add('wd-navbar-filter-advanced-item');

		this.#button = new WDButton({
			label: cfg.label,
			icon: cfg?.icon
		});

		this.prepend(this.#button);

		//may be a better way to do this, but this works for now
		if (cfg.type == 'boolean')
		{
			cfg.type = 'select';
			cfg.simple = true;
			cfg.options = [
				{ label: 'Not Selected', value: '-1' }, 
				{ label: 'Yes', value: '1' }, 
				{ label: 'No', value: '0' }
			];
		}

		this.buildDropdown();

		this.on('filter:apply', () => this.updateItemDisplay());

		this.once('valueform:added', () =>
		{
			this.valueForm.on('options:set', () => this.updateItemDisplay());
		});
	};

	buildDropdown()
	{
		this.#button.setAttribute('data-bs-auto-close', 'false'); //false);


		this.on('valueform:added',() => {
		
			const matchCont = wdc('<div class="item-match"/>');
			const valueCont = wdc('<div class="item-value"/>');
			
			matchCont.append(this.matchForm);
			valueCont.append(this.valueForm);
		
			this.#button.dropdown.append(matchCont,valueCont);

			const tb = wdc('<div class="item-toolbar"/>');
			tb.append(this.hideBtn);
			this.#button.dropdown.append(tb);
		});
		
		if (this.config.menu_position) this.#button.dropdown.parentElement.classList.add(this.config.menu_position);

		//this.#button.addEventListener('shown.bs.dropdown', () => this.valueForm.focus());

		if (this.config.simple) this.#button.dropdown.classList.add('is-simple');
	};

	get dropdown() { return this.#button.dropdown; };

	apply()
	{
		this.#button.dropdown.hide();
		this.triggerApply();
	}

	get hideBtn()
	{
		if (!this.#hideBtn)
		{
			this.#hideBtn = new WDButton({label:'Close Menu',size:'sm',fasIcon:'times',theme:'primary'});
			this.#hideBtn.on('click', () => this.#button.dropdown.hide());
		};

		return this.#hideBtn;
	};

	/**
		* once a value is set, update the button text to reflect
		* what's going on 
		*/
	updateItemDisplay()
	{
		this.#button.label = `${this.config.label} ${this.matchLabel} ${this.valueLabel}`;
	};

	get matchLabel()
	{
		const val = this.matchForm.value;

		const opt = this.matchOptions.find( x => x.value == val);
		return opt ? (opt.short_label || opt.label) : null;
	};

};

customElements.define('wd-navbar-filter', WDNavbarFilter);
customElements.define('wd-navbar-filter-item', WDNavbarFilterItem);
customElements.define('wd-navbar-filter-advanced-item', WDNavbarFilterAdvancedItem);

